import React from "react";
import { Box, Typography } from "@mui/material";
import Image from "react-cool-img";
import NewColors from "../themes/NewColors";
import completion from "../assets/noun-completed-2350074-FFFFFF.svg";

export interface EmptyStateCardProps {
  /**
   * The image source to display on the left side
   * @default completion icon
   */
  imageSrc?: string;
  
  /**
   * Alt text for the image
   * @default "empty state"
   */
  imageAlt?: string;
  
  /**
   * Width of the image
   * @default 200
   */
  imageWidth?: number;
  
  /**
   * Height of the image
   * @default 200
   */
  imageHeight?: number;
  
  /**
   * The text content to display
   */
  text: string;
  
  /**
   * Background of the card - can be a solid color or CSS gradient
   * @default triadic gradient from NewColors
   */
  background?: string;
  
  /**
   * Border radius of the card
   * @default 20
   */
  borderRadius?: number;
  
  /**
   * Padding inside the card
   * @default 50
   */
  padding?: number;
  
  /**
   * Max width of the text content
   * @default 450
   */
  textMaxWidth?: number;
  
  /**
   * Font size of the text
   * @default 24
   */
  fontSize?: number;
  
  /**
   * Text color
   * @default "white"
   */
  textColor?: string;
}

const EmptyStateCard: React.FC<EmptyStateCardProps> = ({
  imageSrc = completion,
  imageAlt = "empty state",
  imageWidth = 200,
  imageHeight = 200,
  text,
  background = NewColors.getTriadicGradient("to right"),
  borderRadius = 20,
  padding = 50,
  textMaxWidth = 450,
  fontSize = 24,
  textColor = "white",
}) => {
  return (
    <Box
      style={{
        borderRadius,
        background,
        padding,
      }}
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Image 
          src={imageSrc} 
          alt={imageAlt} 
          height={imageHeight} 
          width={imageWidth} 
        />
        <Typography
          style={{
            color: textColor,
            fontWeight: "bold",
            fontSize,
            maxWidth: textMaxWidth,
          }}
        >
          {text}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmptyStateCard;